module.exports = __webpack_public_path__ + "static/bg-e8f10dc764aa7e375aa0ee3d2e1bfabd.jpg";